import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';

const PaymentConfirmation = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  
  // Mock data - would come from props or state in real implementation
  const totalAmount = 550.00;
  const customerDetails = {
    name: 'John Doe',
    address: '123 Main St, Anytown, USA',
    email: 'john.doe@example.com',
    date: '05/15/2023'
  };

  const handleSendReceipt = () => {
    // Implementation for sending receipt via email
    if (email) {
      // API call would go here
      alert(`Receipt sent to ${email}`);
      setEmail('');
    }
  };

  return (
    <div className="max-h-screen bg-white flex flex-col ">
      {/* Content */}
      <div className="flex-1 flex flex-col justify-between">
        {/* Success Icon */}
        <div className="border border-dashed border-gray-300 rounded-lg mx-4 mt-4 p-6 flex flex-col items-center">
          <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center mb-4">
            <FaCheck className="text-white text-3xl" />
          </div>
          
          <div className="text-center">
            <p className="text-gray-600 mb-1">Total</p>
            <p className="text-2xl font-bold">${totalAmount.toFixed(2)}</p>
          </div>
         
          {/* Customer Details */}
          <div className="w-full mt-6 space-y-3 bg-gray-100 p-4 rounded-lg" >
            <div className="flex">
              <p className="w-20 text-gray-700 font-bold">Name</p>
              <p className="flex-1 text-gray-800">{customerDetails.name}</p>
            </div>
            
            <div className="flex">
              <p className="w-20 text-gray-700 font-bold">Address</p>
              <p className="flex-1 text-gray-800 ">{customerDetails.address}</p>
            </div>
            
            <div className="flex">
              <p className="w-20 text-gray-700 font-bold">Email</p>
              <p className="flex-1 text-gray-800">{customerDetails.email}</p>
            </div>
            
            <div className="flex">
              <p className="w-20 text-gray-700 font-bold">Date</p>
              <p className="flex-1 text-gray-800">{customerDetails.date}</p>
            </div>
          </div>
          
          {/* Email Receipt Section */}
          <div className="w-full ">
            <div className="relative flex items-center py-3">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="flex-shrink mx-3 text-gray-600">Email Receipt</span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div>
            
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
              className="w-full border border-gray-300 rounded-md p-2.5 mb-3"
            />
            
            <button 
              onClick={handleSendReceipt}
              className="w-full bg-gray-200 text-gray-800 py-3 rounded-md font-medium"
            >
              Send Receipt
            </button>
          </div>
        
      
          
        </div>
        <div className="p-4 flex justify-center items-center ">
        <button 
          onClick={() => navigate('/')}
          className="p-4 bg-blue-600 text-white rounded-full"
        >
            Back to Appointments
          {/* <FaArrowLeft className="text-gray-700" /> */}
        </button>
      </div>
      </div>
      
  
    
    </div>
  );
};

export default PaymentConfirmation;